import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ReleaseNotesResponse } from "./@types";

type Params = {
  languageType: string;
  subscription: string;
};

const fetchReleaseNotes = async (
  params: Params,
): Promise<ReleaseNotesResponse> => {
  const { data } = await apiInputService.get<ReleaseNotesResponse>(
    `/releaseNotes/findReleaseBySubscription/${params.subscription}/${params.languageType}`,
  );
  return data;
};

export const useGetReleaseNotes = (params: Params, options?: any) => {
  return useQuery(["releaseNotes"], () => fetchReleaseNotes(params), {
    ...options,
    staleTime: Infinity,
  });
};
